
export class QuotationCoverageInsuredInsurableDO {

	public id: Number = null;

	public categoryCd: String = null;

	public insurableCd: String = null;

	public insurableValue: DoubleRange = null;

	public appliedForInsurableValue: DoubleRange = null;
	
	public stockCategoryCd: String = null;

	public getId() {
		return this.id;
	}
	public setId(id) {
		this.id = id;
	}

	public getCategoryCd() {
		return this.categoryCd;
	}
	public setCategoryCd(categoryCd: String) {
		this.categoryCd = categoryCd;
	}

	public getInsurableCd() {
		return this.insurableCd;
	}
	public setInsurableCd(insurableCd: String) {
		this.insurableCd = insurableCd;
	}

	public getInsurableValue() {
		return this.insurableValue;
	}
	public setInsurableValue(insurableValue: DoubleRange) {
		this.insurableValue = insurableValue;
	}

	public getAppliedForInsurableValue() {
		return this.appliedForInsurableValue;
	}
	public setAppliedForInsurableValue(appliedForInsurableValue: DoubleRange) {
		this.appliedForInsurableValue = appliedForInsurableValue;
	}

	public getStockCategoryCd() {
		return this.stockCategoryCd;
	}
	public setStockCategoryCd(stockCategoryCd: String) {
		this.stockCategoryCd = stockCategoryCd;
	}
}
